import * as t from './actionTypes';
import {
  DataFeedDeleteResponseAction,
  DataFeedErrorAction,
  DataFeedFetchRequestAction,
  DataFeedFetchResponseAction,
  DataFeedUpdateRequestAction,
  DataFeedUpdateResponseAction,
} from './actions';
import { DataFeeds } from './types';

export type DataFeedsReducerAction =
  | DataFeedDeleteResponseAction
  | DataFeedErrorAction
  | DataFeedFetchRequestAction
  | DataFeedFetchResponseAction
  | DataFeedUpdateRequestAction
  | DataFeedUpdateResponseAction;

export type DataFeedsState = {
  error: string;
  isFetching: boolean;
  feeds: DataFeeds;
};

export const initialState: DataFeedsState = {
  error: '',
  isFetching: false,
  feeds: {},
};

export const dataFeedsReducer = (
  state: DataFeedsState = initialState,
  action = {} as DataFeedsReducerAction,
) => {
  switch (action.type) {
    case t.FETCH_DATA_FEEDS_REQUEST:
    case t.UPDATE_DATA_FEEDS_REQUEST:
    case t.DELETE_DATA_FEEDS_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case t.DELETE_DATA_FEEDS_ERROR:
    case t.FETCH_DATA_FEEDS_ERROR:
    case t.UPDATE_DATA_FEEDS_ERROR: {
      const apiErrorAction = action as DataFeedErrorAction;
      return {
        ...state,
        error: apiErrorAction.error,
        isFetching: false,
      };
    }

    case t.DELETE_DATA_FEEDS_RESPONSE: {
      const clone = { ...state.feeds };
      const apiDeleteResponseAction = action as DataFeedDeleteResponseAction;
      if (apiDeleteResponseAction.id) {
        delete clone[apiDeleteResponseAction.id];
      }

      return {
        ...state,
        error: '',
        isFetching: false,
        feeds: clone,
      };
    }

    case t.FETCH_DATA_FEEDS_RESPONSE: {
      const fetchDataFeedsResponseAction = action as DataFeedFetchResponseAction;
      return {
        ...state,
        error: '',
        isFetching: false,
        feeds: fetchDataFeedsResponseAction.payload,
      };
    }

    case t.UPDATE_DATA_FEEDS_RESPONSE: {
      // payload is always a DataFeed
      const updateDataFeedsResponseAction = action as DataFeedUpdateResponseAction;
      return {
        ...state,
        feeds: {
          ...state.feeds,
          [updateDataFeedsResponseAction.payload.id]: updateDataFeedsResponseAction.payload,
        },
        error: '',
        isFetching: false,
      };
    }

    case t.CLEAR_DATA_FEEDS_ERROR: {
      return {
        ...state,
        error: '',
      };
    }

    default: {
      return state;
    }
  }
};
